let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d4a7k")).then(() => parcelRequire('l2pGG'));